import { redirect } from 'react-router';
import { setUser, getToken, clearToken } from '@repo/api-client/lib/auth';
import { authApi } from '@repo/api-client';

const isAuthError = (error: unknown): boolean => {
  if (error && typeof error === 'object' && 'status' in error) {
    const status = (error as { status: number }).status;
    return status === 401 || status === 403;
  }
  return false;
};

export const anonymousLoader = async () => {
  const token = getToken();
  if (token) {
    try {
      await authApi.getCurrentUser();
      return redirect('/');
    } catch (error) {
      // Only clear token on auth errors (401/403), not server errors (5XX)
      if (isAuthError(error)) {
        return clearToken();
      }
      // For other errors (5XX), assume token might still be valid
      return redirect('/');
    }
  }
  return null;
};

export const protectedLoader = async () => {
  const token = getToken();
  if (!token) {
    return redirect('/login');
  }
  try {
    const user = await authApi.getCurrentUser();
    setUser(user);
    return null;
  } catch (error) {
    // Only redirect to login on auth errors (401/403), not server errors (5XX)
    if (isAuthError(error)) {
      return redirect('/login');
    }
    // Re-throw other errors so they're handled by the error boundary
    throw error;
  }
};
